var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('AppMain',{attrs:{"appEditionLog":_vm.appEditionLog,"appInfo":_vm.appInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }